var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "pitaya" } },
    [
      _c("detect-network", {
        on: { "detected-condition": _vm.connectionDetected },
      }),
      _vm._v(" "),
      _vm.connected || _vm.connectionOverridden
        ? _c(
            "div",
            [
              _c(
                "localizer",
                [
                  _c("notifications", {
                    attrs: { group: "pitaya", position: "bottom right" },
                  }),
                  _vm._v(" "),
                  _c("vue-progress-bar"),
                  _vm._v(" "),
                  _c("router-view"),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            [
              _c("offline", {
                attrs: { connectionOverride: _vm.connectionOverride },
                on: {
                  connectionOverridden: function ($event) {
                    _vm.connectionOverridden = true
                  },
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }